import { React } from 'react';
import { styled } from '@mui/system';

const TitleBox = styled('div')(({ theme }) => ({
  width: '383px',
  padding: '10px 6px 0',
  borderBottom: '2px solid rgb(166,146,123)',
  [theme.breakpoints.down('md')]: {
    width: '350px',
  },
}));

const TitleArea = styled('input')(({ theme }) => ({
  height: '20px',
  borderStyle: 'hidden',
  background: 'none',
  outline: 'none',
  fontFamily: 'Fjalla One',
  fontStyle: 'normal',
  fontWeight: '400px',
  fontSize: '18px',
  lineHeight: '20px',
  color: 'black',
  '&::placeholder': {
    color: 'rgba(153, 152, 154, 0.7)',
  },
}));

const ErrorMessage = styled('div')({
  fontSize: '12px',
  color: 'red',
  height: '12px',
  paddingLeft: '8px',
  lineHeight: '12px',
  paddingTop: '2px',
});

const ErrorMessageEmpty = styled('div')({
  height: '12px',
  paddingTop: '2px',
});

const NoteEditTitle = ({ formik }) => {
  return (
    <>
      <TitleBox>
        <TitleArea
          type="text"
          name="title"
          placeholder="Add your title"
          value={formik.values.title}
          onChange={formik.handleChange}
        />
      </TitleBox>
      {formik.errors.title && formik.touched.title ? (
        <ErrorMessage>Please enter your title</ErrorMessage>
      ) : (
        <ErrorMessageEmpty />
      )}
    </>
  );
};

export default NoteEditTitle;
